import { createMigrate } from "redux-persist";

/**
 * Since this is the FIRST migration ever,
 * we assume old users are on version 0
 */

export const migrations = {
    // 🔥 Version 1 migration (first ever)
    1: (state: any) => {
        if (!state) return state;

        return {
            ...state,
            items: {
                ...state.items,

                // ✅ ADD missing profileCompletionFlags safely
                profileCompletionFlags: {
                    has_active_subscription: false,
                    has_subscription_expired: false,
                    has_free_subscription: false,
                    has_investment_profile_completed: false,
                    has_want_to_sell_profile_completed: false,
                    has_want_to_grow_profile_completed: false,
                    has_investor_profile_completed: false,
                    has_investment_subscription: false,
                    has_want_to_sell_subscription: false,
                    has_want_to_grow_subscription: false,
                    has_investor_subscription: false,
                    has_investment_free_subscription: false,
                    has_want_to_sell_free_subscription: false,
                    has_want_to_grow_free_subscription: false,
                    has_investor_free_subscription: false,
                    has_investment_subs: false,
                    has_want_to_sell_subs: false,
                    has_want_to_grow_subs: false,
                    has_investor_subs: false
                },
            },
        };
    },


};

export const migrate = createMigrate(migrations, {
    debug: false, // set true temporarily if needed
});
